// extracted by mini-css-extract-plugin
export default {"wrapper":"CorrectionRequests_wrapper__ST8wd"};